var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51668 3.51662C8.20581 -1.17257 15.7949 -1.17186 20.4834 3.51662C25.1726 8.20575 25.1719 15.7949 20.4834 20.4834C15.7942 25.1726 8.20515 25.1718 3.51668 20.4834C-1.1726 15.7942 -1.17185 8.20505 3.51668 3.51662ZM1.97353 12C1.97353 17.5286 6.47139 22.0264 12 22.0264C17.5286 22.0264 22.0264 17.5286 22.0264 12C22.0264 6.47143 17.5286 1.97356 12 1.97356C6.47139 1.97356 1.97353 6.47138 1.97353 12ZM11.1034 7.71833L15.6082 11.2221C16.1155 11.6167 16.1148 12.3838 15.6082 12.7778L11.1034 16.2816C10.4632 16.7795 9.51292 16.3279 9.51292 15.5038V8.49621C9.51292 7.67783 10.457 7.21552 11.1034 7.71833ZM11.4838 10.5111V13.4889L13.3981 12L11.4838 10.5111Z",
    fill: "#F0AB2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.daf34e31.svg";
export { ForwardRef as ReactComponent };